type ChannelMetadata = {
  id: "villavilla" | "admiralstrand" | "eloverblik";
  label: string;
  description: string;
  bankMatchKeywords?: string[];
  incomeAccountCode?: string;
  incomeAccountName?: string;
  balanceAccountCode?: string;
  balanceAccountName?: string;
};

export const channelMetadata: readonly ChannelMetadata[] = [
  {
    id: "villavilla",
    label: "VillaVilla",
    description: "Owner portal bookings and price calendar.",
    bankMatchKeywords: ["villavilla", "villa villa"],
    incomeAccountCode: "4110",
    incomeAccountName: "Rental income - VillaVilla",
    balanceAccountCode: "1310",
    balanceAccountName: "Channel balance - VillaVilla",
  },
  {
    id: "admiralstrand",
    label: "AdmiralStrand",
    description: "Owner economy and booking calendar.",
    bankMatchKeywords: ["admiralstrand", "admiral strand"],
    incomeAccountCode: "4120",
    incomeAccountName: "Rental income - Admiral Strand",
    balanceAccountCode: "1320",
    balanceAccountName: "Channel balance - Admiral Strand",
  },
  {
    id: "eloverblik",
    label: "ElOverblik",
    description: "Electricity consumption from ElOverblik Customer API.",
  },
] as const;

export type ChannelId = ChannelMetadata["id"];

const channelIdSet = new Set(channelMetadata.map((channel) => channel.id));

export const isChannelId = (value: string): value is ChannelId =>
  channelIdSet.has(value as ChannelId);

export const getChannelMetadata = (channelId: ChannelId) =>
  channelMetadata.find((channel) => channel.id === channelId) ?? null;

export const getChannelLabel = (channelId: ChannelId) =>
  getChannelMetadata(channelId)?.label ?? channelId;

export const getChannelDescription = (channelId: ChannelId) =>
  getChannelMetadata(channelId)?.description ?? "";

export const getChannelIncomeAccountCode = (channelId: ChannelId) =>
  getChannelMetadata(channelId)?.incomeAccountCode ?? null;

export const getChannelIncomeAccountName = (channelId: ChannelId) =>
  getChannelMetadata(channelId)?.incomeAccountName ?? null;

export const getChannelBalanceAccountCode = (channelId: ChannelId) =>
  getChannelMetadata(channelId)?.balanceAccountCode ?? null;

export const getChannelBalanceAccountName = (channelId: ChannelId) =>
  getChannelMetadata(channelId)?.balanceAccountName ?? null;

export const getChannelBankLinkKeywords = (channelId: ChannelId) =>
  getChannelMetadata(channelId)?.bankMatchKeywords ?? [];
